export enum FormaDeEntrega {
  RECEBER_EM_CASA = 'Receber em casa',
  RETIRAR = 'Retirar',
  COMERNOLOCAL = 'Comer no local'
}
